import { getData } from '@/utils/axiosUtils';

export const getRegions = async () =>
    await getData('/Regions', { 'X-RequestScope': '80' });
